/*
 * @Author: wuziyang 764401855@qq.com
 * @Date: 2022-09-14 11:12:41
 * @LastEditors: wuziyang 764401855@qq.com
 * @LastEditTime: 2022-09-14 14:20:44
 * @FilePath: \tsdx-template\src\components\PitToolTip\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useRef, CSSProperties, FC } from 'react';
import styles from '../../styles/pit-tooltip.module.scss';
console.log(styles, 'styles');
interface PitToolTipProps {
  context?: string;
  show?: boolean;
  placement?: string;
  children?: any;
  className?: string;
  style?: CSSProperties;
}
const PitToolTip: FC<PitToolTipProps> = function ({
  children,
  context,
  show = true,
  placement = 'top',
}) {
  const conter = useRef(null);
  const tooltip = useRef(null);
  return (
    <div className={styles['pit-tooltip_contenar']} ref={conter}>
      {show && context ? (
        <div
          className={`${styles['pit-tooltip']} ${styles[placement]}`}
          ref={tooltip}
        >
          {context}
        </div>
      ) : (
        ''
      )}
      <div>{children}</div>
    </div>
  );
};
export default PitToolTip;
